import { I18nType } from '@/ui/types/i18n.types';

const componentName = 'forms';
const submodule = 'errors';

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default function emailRule(i18n: I18nType) {
  return function rule(property: string) {
    return [
      (v: string) => (v && emailRegex.test(v))
        || i18n.getFormattedText(componentName, submodule, 'email', { property }),
    ];
  };
}
